import React from 'react';
import ComingSoon from '../common/ComingSoon';

function Results() {
  return <ComingSoon title="Results Management" />;
}

export default Results;
